<template>
  <el-card class="box-card">
    <div slot="header" class="cardheader">
      <div>{{ $t('lang.loginPage.login') }}</div>
    </div>
    <div class="request-body">
      <el-button size="mini" style="width: 80%" type="ceibsprimary" @click="goto('confirmInfo')">
        {{ $t('lang.loginPage.createNewApply') }}
      </el-button>
      <el-divider></el-divider>
      <el-button size="mini" style="width: 80%" type="ceibsprimary" @click="goto('applyList')">
        {{ $t('lang.loginPage.applyQuery') }}
      </el-button>
    </div>
    <el-link type="info" style="margin-top: 10px;" @click="logout">
      {{ $t('lang.loginPage.logout') }}
    </el-link>
  </el-card>
</template>

<script>
import { removeToken } from '@/util/util.ruquest'

export default {
  name: 'LoginCard',
  inject: ['reload'],
  methods: {
    goto (url) {
      this.$router.push(url)
    },
    logout () {
      removeToken()
      this.reload()
    }
  }
}
</script>

<style scoped>
.box-card {
  background-color: unset;
  border-radius: 8px;
  border: none;
  box-shadow: 3px 7px 12px 1px rgb(0 0 0 / 45%);
}

.cardheader {
  background: linear-gradient(to left, #a2100e, rgba(162, 16, 14, 0.5));
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 25px;
  color: #fff;
  font-weight: bold;
  padding: 0 20px;
  text-shadow: 2px 2px 5px rgb(8 8 8 / 19%);
  text-align: center;
}

.request-body {
  text-align: center;
}

.card-tip {
  font-size: 14px;
  color: rgba(86, 86, 86, 0.63);
  font-weight: bold;
  margin-top: 5px;
  margin-bottom: 5px;
}

/deep/ .el-input__inner {
  background-color: #c5c5c5;
  border-radius: 0;
  height: 34px;
  line-height: 34px;
  margin-bottom: 5px;
  text-align: center;
}

/deep/ .el-input__inner::placeholder {
  color: #565656;
}

/deep/ .el-card__header {
  padding: 0;
}

/deep/ .el-card__body {
  background-color: rgba(255, 255, 255, 0.85);
  /*height: 160px;*/
}
</style>
